/*
 * @Author: pyx 3245266940@qq.com
 * @Date: 2022-07-30 11:44:30
 * @LastEditors: pyx 3245266940@qq.com
 * @LastEditTime: 2023-04-18 13:42:06
 * @FilePath: \org-wx-front\src\utils\api\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '../http'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */


// get请求
export function getListAPI(params){
    return http.get(`/getList.json`,params)
}
// post请求
export function postFormAPI(params){
    return http.post(`/postForm.json`,params)
}
// put 请求
export function putSomeAPI(params){
    return http.put(`/putSome.json`,params)
}
// delete 请求
export function deleteListAPI(params){
    return http.delete(`/deleteList.json`,params)
}


// 检验是否存在
export function postCheckAPI(params){
    return http.post(`/rbac/wx/tenant/user/third/account/create/pre/check`,params)
}
// 发送验证码
export function postVerifyCodeSendAPI(params){
    return http.post(`/rbac/wx/openapi/verify/code/send`,params)
}
// 检验员工是否存在
export function getStaffCheckExistAPI(params){
    return http.get(`/rbac/wx/tenant/staff/check/exist`,params)
}
// 绑定(创建第三方账号)
export function postBindAPI(params){
    return http.post(`/rbac/wx/tenant/user/third/account/create`,params)
}
// 用户第三方账号注册/领取产品购买优惠券
export function postAccountRegisterAPI(params){
    return http.post(`/rbac/wx/third/account/register`,params)
}
// 领取优惠券（已登录用户/已授权用户）
export function postCouponReceiveAPI(params){
    return http.post(`/rbac/wx/discount/coupon/receive`,params)
}
// 获取优惠券列表
export function getDiscountCouponListAPI(params){
    return http.get(`/rbac/wx/discount/coupon/list`,params)
}
// 登录
export function postLoginAPI(params){
    return http.post(`/rbac/wx/tenant/user/login`,params)
}
// 检查优惠券是否领取
export function postCouponReceiveCheckAPI(params){
    return http.post(`/rbac/wx/discount/coupon/receive/check`,params)
}
// 用户第三方授权信息注销
export function deleteAccountCancelAPI(params){
    return http.delete(`/rbac/wx/tenant/user/third/account/cancel`,params)
}
export function verificationAPI(params){
    return http.post(`/ti/wx/verify/sms/verifyCode`,params)
}
// 刷新用户登录授权信息接口
export function getAuthsRefreshAPI(params){
    return http.get(`/rbac/wx/institution/user/auths/refresh`,params)
}
// 获取授权列表
export function getAuthorizeListAPI(params){
    return http.get(`/rbac/wx/tenant/user/third/account/list`,params)
}
// 授权
export function postAuthorizationAPI(params){
    return http.post(`/rbac/wx/tenant/user/third/account/authorize`,params)
}
// 取消授权
export function deleteAuthorizationAPI(params){
    return http.delete(`/rbac/wx/tenant/user/third/account/authorize/cancel`,params)
}
// 通知
export function getNoticeRecordsAPI(params){
    return http.get(`/wfm/wx/institution/noticeTracking/page`,params)
}
// 获取活动列表
export function getActivityListAPI(params){
    return http.get(`/edu/wx/institution/activities/list`,params)
}
// 获取活动学员
export function getActivityStuAPI(params){
    return http.get(`/edu/wx/institution/activities/students`,params)
}
// 获取课表
export function getCourseDataAPI(params){
    return http.get(`/edu/wx/institution/teacher/schedule`,params)
}
// 获取课程详情
export function getCourseDetailsAPI(params){
    return http.get(`/edu/wx/institution/teacher/schedule/details`,params)
}
// 获取上课学员
export function getCourseStuAPI(params){
    return http.get(`/edu/wx/institution/schedule/students`,params)
}
// 获取员工个人详情
export function getUserInfoAPI(params){
    return http.get(`/rbac/wx/institution/staff/profile`,params)
}

//获取管辖机构列表
export function getManageInstitutionAPI(params){
    return http.get(`/rbac/wx/institution/user/institution/auths/list`,params)
}

//获取管辖机构下的校区列表
export function getInstitutionCampusAPI(params){
    return http.get(`/rbac/wx/institution/user/institution/auths/campus/list`,params)
}

// 移动端支付
export function postPayMobileAPI(params){
    return http.post(`/oms/pc/tablePay`,params)
}
 